import { Checkbox, Grid, TableCell, TableRow } from "@mui/material";
import React from "react";

import DensityMediumIcon from "@mui/icons-material/DensityMedium";

import { capitalizeFirstLetter, images } from "../constants";
import moment from "moment";

const AreaAlbumsTableRow = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  handleImagePreviewModalOpen,
  setSelectedImage,
  showPosition,
  removeRow,
  provided,
  position,
}) => {
  const rows = Array.from({ length: 20 }, (_, index) => index + 1);

  const handleRemoveRow = () => {
    removeRow([row.id]);
  };

  return (
    <TableRow
      ref={provided.innerRef}
      {...provided.draggableProps}
      hover
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        height: 48,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        padding="checkbox"
        style={{ background: "#fff" }}
        onClick={(event) => handleClickRow(event, row.id)}
      >
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>
      <TableCell
        // component="th"
        id={labelId}
        //scope="row"
        padding="none"
        // onClick={handleNavigateToDetails}
        style={tableTitleFieldStyles}
      >
        {row?.title}
        {showPosition && (
          <a
            onClick={handleRemoveRow}
            style={{ color: "#BA344C", cursor: "pointer", display: "block" }}
          >
            Remove
          </a>
        )}
      </TableCell>
      <TableCell
        align="center"
        style={{ border: "1px solid #BABABA" }}
        onClick={() => {
          setSelectedImage(
            row?.photoUrl ? row?.photoUrl : images.QuicktaleLogo
          );
          handleImagePreviewModalOpen();
        }}
      >
        {
          <img
            src={
              row?.photoUrl && row?.photoUrl != ""
                ? row?.photoUrl
                : images.QuicktaleLogo
            }
            alt="empty image"
            style={{ width: 45, height: 40 }}
            onError={(e) => {
              e.target.onerror = null; // Prevent infinite loop
              e.target.src = ""; // Set the source to an empty string or a placeholder image URL
            }}
          />
        }
        {/* <img
          src={row?.photoUrl}
          alt="empty image"
          style={{ width: 45, height: 40 }}
        /> */}
      </TableCell>
      <TableCell align="left" style={tableCellStyles}>
        {row?.id}
      </TableCell>
      <TableCell align="left" style={tableCellStyles}>
        {row?.userData != null
          ? row?.userData?.firstName + " " + row?.userData?.lastName
          : row?.createdBy
          ? row?.createdBy
          : ""}
      </TableCell>
      <TableCell align="left" style={tableCellStyles}>
        {capitalizeFirstLetter(row?.privacy)}
      </TableCell>
            <TableCell align="left" style={tableCellStyles}>
        {moment.unix(row?.createdAt.seconds).format("MM/DD/YYYY HH:mm:ss")}
      </TableCell>
      {showPosition && (
        <TableCell
          {...provided.dragHandleProps}
          align="left"
          style={tableStatusCellStyles}
        >
          <Grid container>
            {row?.position
              ? row?.position
              : position
              ? position + 1
              : position == 0
              ? 1
              : ""}
            <DensityMediumIcon
              onClick={() => {}}
              fontSize={"small"}
              style={{
                width: 24,
                height: 24,
                marginLeft: "auto",
                color: "#808080",
              }}
            />
          </Grid>
        </TableCell>
      )}
    </TableRow>
  );
};

export default AreaAlbumsTableRow;

const tableTitleFieldStyles = {
  border: "1px solid #BABABA",
  paddingLeft: 5,
  color: "#00A7CD",
  cursor: "default",
  // fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
};

const tableCellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
};
const tableStatusCellStyles = {
  border: "1px solid #BABABA",
  cursor: "pointer",
  // fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
};
